import { useFormContext } from 'react-hook-form';

import { MultiSelect } from 'src/common/primitives/MultiSelect/MultiSelect';
import { SettingsRowHeader } from 'src/features/settings/OrganizationSettingsForm/components/SettingsRowHeader';

import type { SelectOption } from '@bambi/component-library/src/components/inputs/Select/SelectOption/SelectOption';

export const TRIP_REQUIRED_FIELD_OPTIONS = [
  {
    label: 'Authorization ID',
    value: 'authorization_id',
  },
  {
    label: 'External Trip ID',
    value: 'external_trip_id',
  },
  {
    label: 'Insurance Policy ID',
    value: 'insurance_policy_id',
  },
  {
    label: 'Member ID',
    value: 'payer_passenger_external_id',
  },
  {
    label: 'Passenger Phone Number',
    value: 'passenger_phone_number',
  },
  {
    label: 'Passenger Weight',
    value: 'passenger_weight',
  },
  {
    label: 'Requested By Name',
    value: 'booked_by_name',
  },
  {
    label: 'Requested By Phone Number',
    value: 'booked_by_phone_number',
  },
];

export function TripRequiredFieldSettings() {
  const form = useFormContext();
  const tripRequiredFields = form.watch('trip_required_fields') || {};

  const selected = TRIP_REQUIRED_FIELD_OPTIONS.filter(
    (field) => tripRequiredFields[field.value]
  );

  const onChange = (options: SelectOption[]) => {
    const newValues = TRIP_REQUIRED_FIELD_OPTIONS.reduce<
      Record<string, boolean>
    >(
      (acc, field) => ({
        ...acc,
        [field.value]: options.some((option) => option.value === field.value),
      }),
      {}
    );

    form.setValue('trip_required_fields', newValues);
  };

  return (
    <div className="grid grid-cols-1 gap-x-8 gap-y-4 border-b border-gray-900/10 py-5 md:grid-cols-4">
      <SettingsRowHeader
        title="Required Trip Fields"
        description="Organization defaults for fields that are required for a trip."
      />
      <div className="mt-3 flex w-full flex-col gap-4 md:col-span-3">
        <MultiSelect
          options={TRIP_REQUIRED_FIELD_OPTIONS}
          selected={selected}
          onChange={onChange}
          placeholder="Select required trip fields"
        />
      </div>
    </div>
  );
}
